module.exports = __webpack_public_path__ + "img/pantanal.b7e8374c.jpg";